import { render, staticRenderFns } from "./FrameSidebar.vue?vue&type=template&id=97c2530e&scoped=true&"
import script from "./FrameSidebar.vue?vue&type=script&lang=ts&"
export * from "./FrameSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./FrameSidebar.vue?vue&type=style&index=0&id=97c2530e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c2530e",
  null
  
)

export default component.exports